import 'utility/config';
import React from 'react';
import { RouterProvider } from '@tanstack/react-router';

import './style/custom.css'

import { router } from './routes/routeTree';

const App = () => {
    return <RouterProvider router={router} />;
};

export default App;
